import styled from "styled-components";

const getColorStyles = (color) => {
  switch (color) {
    case 'red':
      return {
        color: '#FFFFFF',
        border: '1px solid rgba(220, 53, 70, 0.54)',
        backgroundColor: 'rgba(220, 53, 70, 0.54)'
      };
    case 'green':
      return {
        color: '#FFFFFF',
        border: '1px solid rgba(76, 175, 80, 0.54)',
        backgroundColor: 'rgba(76, 175, 80, 0.54)'
      };
    case 'white':
    default:
      return {
        color: '#FFFFFF',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      };
  }
};

export const CriticalText = styled.h4`
    color: ${props => getColorStyles(props.color).color};
    border: ${props => getColorStyles(props.color).border};
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
    background-color: ${props => getColorStyles(props.color).backgroundColor};
    padding: 8px 16px;
    width: 100%;
`;
